/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Per_MonthInputs */

const en_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mo`)
};

const es_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mes`)
};

const fr_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mois`)
};

const de_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/Monat`)
};

const ja_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/月`)
};

const zh_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/月`)
};

const ar_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/شهر`)
};

const id_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/bln`)
};

const it_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mese`)
};

const ru_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/мес`)
};

const pt_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mês`)
};

const ko_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/월`)
};

/**
* | output |
* | --- |
* | "/mo" |
*
* @param {Pricing_Per_MonthInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_per_month = /** @type {((inputs?: Pricing_Per_MonthInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Per_MonthInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_per_month(inputs)
	if (locale === "es") return es_pricing_per_month(inputs)
	if (locale === "fr") return fr_pricing_per_month(inputs)
	if (locale === "de") return de_pricing_per_month(inputs)
	if (locale === "ja") return ja_pricing_per_month(inputs)
	if (locale === "zh") return zh_pricing_per_month(inputs)
	if (locale === "ar") return ar_pricing_per_month(inputs)
	if (locale === "id") return id_pricing_per_month(inputs)
	if (locale === "it") return it_pricing_per_month(inputs)
	if (locale === "ru") return ru_pricing_per_month(inputs)
	if (locale === "pt") return pt_pricing_per_month(inputs)
	return ko_pricing_per_month(inputs)
});